
import React from 'react';
import { Button } from "@/components/ui/button";
import { TrendingUp, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const WaitlistSuccess = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 py-12">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-[#9E7C47] rounded-full filter blur-[120px] animate-pulse-slow"></div>
        <div className="absolute bottom-20 left-1/4 w-96 h-96 bg-[#F9F1A9] rounded-full filter blur-[120px] animate-pulse-slow"></div>
      </div>
      
      <div className="w-full max-w-md text-center relative z-10">
        <div className="mb-8 flex flex-col items-center">
          <div className="relative mb-6">
            <img src="/coin_logo.png" alt="AI Wealth Manager" className="h-24 w-24" />
            <CheckCircle className="h-6 w-6 text-green-500 absolute -top-1 -right-1 bg-black rounded-full" />
          </div>
          
          <h1 className="text-3xl font-bold mb-4 text-white">Thank You!</h1>
          <p className="text-white/70 mb-6">
            You've successfully joined our waitlist. We'll give you access as soon as possible and notify you via email.
          </p>
          
          <div className="glass-card p-6 rounded-xl mb-8">
            <p className="text-[#9E7C47] font-semibold mb-2">What's next?</p>
            <p className="text-white/60 text-sm">
              While you wait, stay updated with the latest market insights and financial news.
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <Link to="/top-5-news">
            <Button className="w-full bg-[#9E7C47] hover:bg-[#9E7C47]/90 font-semibold text-white py-3" size="lg">
              <TrendingUp className="h-5 w-5 mr-2" />
              Read Top 5 Market News
            </Button>
          </Link>
          
          <Link to="/">
            <Button variant="outline" className="w-full border-white/10 text-white hover:bg-white/10" size="lg">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WaitlistSuccess;
